"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubjectIdDto = exports.SubjectYearIdDto = exports.SubjectYearByGlobalIdDto = exports.SubjectYearSearchDto = exports.SubjectYearFindByGlobalIdDto = exports.SubjectYearDto = exports.SubjectYearUpdateDto = exports.SubjectYearCreate = void 0;
class SubjectYearCreate {
}
exports.SubjectYearCreate = SubjectYearCreate;
class SubjectYearUpdateDto {
}
exports.SubjectYearUpdateDto = SubjectYearUpdateDto;
class SubjectYearDto {
}
exports.SubjectYearDto = SubjectYearDto;
class SubjectYearFindByGlobalIdDto {
}
exports.SubjectYearFindByGlobalIdDto = SubjectYearFindByGlobalIdDto;
class SubjectYearSearchDto {
}
exports.SubjectYearSearchDto = SubjectYearSearchDto;
class SubjectYearByGlobalIdDto {
}
exports.SubjectYearByGlobalIdDto = SubjectYearByGlobalIdDto;
class SubjectYearIdDto {
}
exports.SubjectYearIdDto = SubjectYearIdDto;
class SubjectIdDto {
}
exports.SubjectIdDto = SubjectIdDto;
//# sourceMappingURL=subject-year.dto.js.map